import { ITEMS, getRefinableTreasures, getRecipeInfo } from './resources.js';

// Treasures (法宝) module

function listTreasures(state) {
  // 返回背包中所有可装备的法宝
  return Object.keys(state.bag).filter(itemName => {
    const item = ITEMS[itemName];
    return item && item.usable && item.useEffect && item.useEffect.type === 'equip';
  });
}

function useTreasure(state, name) {
  if (!name) return { success: false, messages: ['请指定法宝名称，例如 use 七星宝刀。'] };

  const item = ITEMS[name];
  if (!item || !item.usable || item.useEffect.type !== 'equip') {
    return { success: false, messages: [`${name} 不是可装备的法宝。`] };
  }

  const effect = item.useEffect;
  let messages = [];

  // 应用装备效果
  if (effect.effects) {
    for (const [stat, value] of Object.entries(effect.effects)) {
      if (state[stat] !== undefined) {
        state[stat] += value;
        const statName = {
          attack: '攻击力',
          defense: '防御力',
          mentalDefense: '心防'
        }[stat] || stat;
        messages.push(`${statName}提升${value}点`);
      }
    }
  }

  if (messages.length > 0) {
    return {
      success: true,
      messages: [`装备${name}，${messages.join('，')}。`]
    };
  } else {
    return { success: false, messages: [`装备${name}，但没有明显效果。`] };
  }
}

// Refining treasures (炼器)
function refineTreasure(state, treasureName) {
  if (!treasureName) return ['请指定法宝名称，例如 refine_treasure 七星宝刀。'];

  const recipe = getRecipeInfo(treasureName);
  if (!recipe) return [`未知法宝：${treasureName}。`];

  // Check materials
  for (const ingredient of recipe.ingredients) {
    if (!(ingredient.item in state.bag) || state.bag[ingredient.item] < ingredient.count) {
      return [`材料不足：需要 ${ingredient.count} 个 ${ingredient.item}，你有 ${state.bag[ingredient.item] || 0} 个。`];
    }
  }

  // Check skill
  const item = ITEMS[treasureName];
  if (!item.recipe || !state.skills[item.recipe.skill]) {
    return [`需要掌握 ${item.recipe.skill} 才能炼制。`];
  }

  // Consume materials
  for (const ingredient of recipe.ingredients) {
    state.bag[ingredient.item] -= ingredient.count;
    if (state.bag[ingredient.item] <= 0) delete state.bag[ingredient.item];
  }

  // Refine
  const success = Math.random() < recipe.successRate;
  if (success) {
    addItemToBag(state, treasureName);
    return [`炼器成功！获得 ${treasureName} 一件。`];
  } else {
    return [`炼器失败，材料尽失。`];
  }
}

// Helper to add item to bag
function addItemToBag(state, itemName, count = 1) {
  if (state.bag[itemName]) {
    state.bag[itemName] += count;
  } else {
    state.bag[itemName] = count;
  }
}

function listRefinableTreasures() {
  return getRefinableTreasures();
}

function getTreasureRecipe(treasureName) {
  return getRecipeInfo(treasureName);
}

function getAllTreasureRecipes() {
  const treasures = {};
  getRefinableTreasures().forEach(treasureName => {
    treasures[treasureName] = getRecipeInfo(treasureName);
  });
  return treasures;
}

export { listTreasures, useTreasure, refineTreasure, listRefinableTreasures, getTreasureRecipe, getAllTreasureRecipes };
